// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YFKjO","container--centered":"styles_container--centered__Vsrii","main":"styles_main__ofQ7j"};